import { defineComponent as _defineComponent } from 'vue';
import InputText from 'primevue/inputtext';
import DataTable from '@/Components/DataTable.vue';
import Column from 'primevue/column';
import { FilterMatchMode, FilterOperator } from 'primevue/api';
import Sidebar from 'primevue/sidebar';
import PlotDetails from './Details.vue';
import { computed, onMounted, ref } from 'vue';
import { usePage } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import { useRoute } from '@/Plugins/ziggy';
import { useAxios } from '@/Plugins/axios';
import { useSpinner } from '@/Plugins/spinner';
import { useMitt } from '@/Plugins/mitt';
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import { useToastService } from '@/Plugins/toast-service';
import ConfirmationService from '@/Services/ConfirmationService';
import { trans, transChoice } from 'laravel-vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'List',
    setup(__props, { expose }) {
        expose();
        const route = useRoute();
        const axios = useAxios();
        const spinner = useSpinner();
        const emitter = useMitt();
        const toast = useToastService();
        const confirmationService = new ConfirmationService();
        const bulkActionsMenu = ref();
        const plotData = ref();
        const selectedPlots = ref([]);
        const filters = ref({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            code: {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
            },
        });
        const globalFilterFields = ['code'];
        const formPanelVisible = ref(false);
        const page = usePage();
        const plots = computed(() => page.props.value.plots);
        onMounted(() => {
            Inertia.reload({
                only: ['plots'],
                onSuccess: () => {
                    // showPlot(1);
                },
            });
        });
        const bulkActions = ref([
            {
                label: 'Elimina Selezionati',
                icon: 'pi pi-fw pi-trash',
                command: () => deleteSelected(),
                disabled: () => selectedPlots.value.length === 0,
            },
        ]);
        const showPlot = (id) => {
            // fetch plot data
            spinner.show();
            axios
                .get(route('api.plots.show', { plot: id }))
                .then(({ data }) => {
                plotData.value = data.data;
                formPanelVisible.value = true;
            })
                .finally(() => {
                spinner.hide();
            });
        };
        emitter.on('plot-saved', (data) => {
            const index = plots.value.findIndex((p) => p.id === data.id);
            if (index !== -1) {
                plots.value[index] = data;
            }
            else {
                // add new plot only if orchard is the same
                if (data.orchard_id === page.props.value.orchard.id) {
                    plots.value.push(data);
                }
            }
        });
        const deleteSelected = () => {
            confirmationService.confirmDeleteMultiple(selectedPlots.value.length, () => {
                spinner.show();
                axios
                    .post(route('api.plots.destroyMultiple'), {
                    _method: 'DELETE',
                    ids: selectedPlots.value.map((p) => p.id),
                })
                    .then(() => {
                    Inertia.reload({
                        only: ['plots'],
                    });
                    toast.deleteSuccess();
                })
                    .finally(() => {
                    spinner.hide();
                });
            }, () => { });
        };
        const __returned__ = { route, axios, spinner, emitter, toast, confirmationService, bulkActionsMenu, plotData, selectedPlots, filters, globalFilterFields, formPanelVisible, page, plots, bulkActions, showPlot, deleteSelected, get InputText() { return InputText; }, DataTable, get Column() { return Column; }, get Sidebar() { return Sidebar; }, PlotDetails, get Button() { return Button; }, get Menu() { return Menu; }, get trans() { return trans; }, get transChoice() { return transChoice; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
